import React, { useEffect } from "react";

import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { toastMessage } from "utils/toastMessage";


import { TextArea } from "common/InputForm";

import { cancelPrescriptionApi } from "services/prescription-management";
import { useNavigate } from "react-router-dom";

const CancelPrescription = ({
  cancelPrescriptionInstance,
  closeModel,
  detailsData,
}) => {
  console.log("detailsData-----------------detailsData--->", detailsData);
  const [error, setError] = useState({});
  const navigate = useNavigate();

  const [cancelReason, setCancelReason] = useState("");

  const [buttonLoader, setButtonLoader] = useButtonLoader("submit");

  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!cancelReason.length) {
      errorObject["cancelReason"] = "Reason Can't be Empty";
      status = false;
    }
    setError(errorObject);

    return status;
  };

  // Add Brand close modal
  const addBrandCloseModal = () => {
    setError({});
    closeModel();
  };

  // Add Brand handler

  const cancelBannerHandler = async (e) => {
    e.preventDefault();

    if (validation()) {
      setButtonLoader(true);
      try {
        const dataToSend = {
          status: "REJECTED",
          id: detailsData._id,
          rejectionReason: cancelReason,
        };

        const { data } = await cancelPrescriptionApi(dataToSend);
        // console.log();
        if (data.status || data.code === 200) {
          addBrandCloseModal();
toastMessage("Prescription canceled successfully");
          navigate("/prescription-management");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <CustomModal
      className={"add_model"}
      show={cancelPrescriptionInstance}
      handleClose={addBrandCloseModal}
    >
      <h3>Cancel Prescription Reason </h3>

      <div>
        <TextArea
          label="Cancel Prescription Reason"
          value={cancelReason}
          onChange={(e) => {
            setCancelReason(e.target.value);
          }}
        />

        {error["cancelReason"] && (
          <div style={{ color: "red", marginTop: "1rem" }}>
            <p>{error["cancelReason"]}</p>
          </div>
        )}
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addBrandCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={cancelBannerHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default CancelPrescription;
